import { chefs, sale, hero } from "../../assets/images/images";
import React from "react";
import Products from "../../component/Products";
import Services from "../../component/Services/Services";
// import { useSelector } from 'react-redux';
import NavSearch from "../../component/NavSearch/NavSearch";
import { Link } from "react-router-dom";

function Homepage() {
  console.log("Homepage.js");
  return (
    <div className="w-full col-start-1 col-end-13">
      {/* HERO CONTAINER */}
      <div className=" relative  grid grid-cols-12    bg-bgMain gap-8 lg:gap-0">
        <div className="absolute px-[1rem] max-w-[35rem] w-full top-[60%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
          <form className="w-full ml-auto  flex">
            <input
              type="text"
              className="w-[84%] border border-r-transparent border-primary p-3 rounded-l-md placeholder:font-Roboto placeholder:p-2 focus:outline-none font-[300] font-Roboto"
              placeholder="What's your favourite food?"
            />
            <button
              type="submit"
              className="w-[16%] bg-white font-Roboto border-primary font-[300] text-sm border rounded-r-md p-3 text-[#C4C4C4]  "
            >
              Search
            </button>
          </form>
        </div>

        {/* RIGHT */}
        <div className="col-start-2 col-end-12 lg:col-start-4 lg:col-end-12">
          <img
            src={hero}
            className="block h-full object-cover  object-center"
            alt="cake"
          />
        </div>
      </div>
      {/* SPECIAL MEALS OF THE DAY */}
      <div className="w-full px-[2rem] py-[2rem] lg:py-[2rem] lg:px-[9.5rem]">
        <div className="w-full text-center mb-10 font-[400] text-greyPrimary font-Prata text-4xl xl:text-5xl">
          <h1>We serve with love</h1>
        </div>
        <p className="font-Poppins font-[300] text-[#000000] block mx-auto text-lg text-center">
          Check our sepecials meal of the week and get discounts on all our
          meals and swift delivery to what ever location within kathmandu,
          Bhaktapur and Lalitpur
        </p>
        <Products />
      </div>
      <Link to="/menu">
        <div className="flex items-center justify-center">
          <button className="bg-greyPrimary text-white p-2 rounded-md shadow-md">
            View Menu
          </button>
        </div>
      </Link>

      {/* EXPERIENCE */}
      <div className="w-full px-[2rem] py-[2rem] lg:py-[2rem] lg:px-[9.5rem]">
        <div className=" flex gap-8 justify-center">
          {/* Experience */}
          <div className="text-center  ">
            <h1 className="text-2xl font-bold text-header font-poppins xl:text-[2.1rem]">
              10+
            </h1>
            <h1 className="text-[0.7rem] font-normal font-poppins text-greyLight font xl:text-[1rem]">
              YEARS OF EXPERIENCE
            </h1>
          </div>
          {/* Cake items */}
          <div className="text-center ">
            <h1 className="text-2xl font-bold text-header font-poppins xl:text-[2.1rem]">
              500+
            </h1>
            <h1 className="text-[0.7rem] font-normal font-poppins text-greyLight font xl:text-[1rem]">
              FOOD MENU
            </h1>
          </div>
          {/* Bakery Items */}
          <div className="text-center  ">
            <h1 className="text-2xl font-bold text-header font-poppins xl:text-[2.1rem]">
              27+
            </h1>
            <h1 className="text-[0.7rem] font-normal font-poppins text-greyLight font xl:text-[1rem]">
              COUNTRY CUISINE
            </h1>
          </div>
        </div>
      </div>

      {/* SERVICES */}
      <Services />
      {/* from Our customers */}
      <div className="w-full px-[2rem] py-[2rem] lg:py-[2rem] lg:px-[9.5rem] flex flex-col md:flex-row gap-8  lg:gap-16">
        {/* <div className='w-full text-center mb-[2rem]  font-Rochester text-4xl xl:text-5xl'>
          <h1>From Our Customers</h1>
        </div>
        <Customers /> */}

        {/* IMAGE SECTION */}
        <div className="flex-1">
          <img
            src={chefs}
            alt="chefs"
            className="w-full rounded-xl object-cover h-full"
          />
        </div>
        {/* DESCRIPTION SECTION */}
        <div className="flex-1 mb-[3rem]">
          <h1 className="text-[2.5rem] my-6 text-greyPrimary font-SourceSerif font-[600]">
            Order Your Food
          </h1>
          <p className="text-lg mb-4 text-greySecondary font-Poppins">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
            vulputate libero et velit interdum, ac aliquet odio mattis.
          </p>
          <div className="p-3 py-5 rounded-lg text-center text-white bg-purpleMain">
            <h2 className="font-[600] text-[2.5rem] font-Poppins">
              Contact Us
            </h2>
            <h3 className="text-[2rem]">9809487733 , 4474849</h3>
          </div>
          <h2 className="font-Prata text-lg  md:text-[26px] text-center mt-5">
            DURBARMARG,KATHMANDU
          </h2>
        </div>
      </div>
      <div className="flex-col px-[2rem] py-[2rem] lg:py-[2rem] lg:px-[9.5rem] md:flex-row flex gap-16 lg:gap-24 justify-between">
        <div className="flex-1">
          <img
            src={sale}
            alt="sale offer"
            className="block w-full object-contain"
          />
        </div>
        <div className="flex-1 text-greyPrimary">
          <div className="w-full text-center mb-5 font-[700]  font-SourceSerif text-4xl">
            <h1>We Have a Amazing Offers For you!!!</h1>
          </div>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
            vulputate libero et velit interdum, ac aliquet odio mattis. Class
            aptent taciti sociosqu ad litora torquent per conubia nostra, per
            inceptos himenaeos.
          </p>
        </div>
      </div>
    </div>
  );
}
const MemoizedHomepage = React.memo(Homepage);

export default MemoizedHomepage;
